import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import Box from '../../elements/Box';

const LocationSelectorNoResult = (props) => {
  const { children } = props;
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  return (
    <Box className={className} style={style} textAlign="left">
      {children}
    </Box>
  );
};

LocationSelectorNoResult.propTypes = {
  /**
   * Text of the no result.
   */
  children: PropTypes.string,
};

LocationSelectorNoResult.defaultProps = {
  children: '',
};

export default LocationSelectorNoResult;
